module.exports = __webpack_public_path__ + "img/placeholder-bp.4a7c2fb4.svg";